export default __webpack_public_path__ + "images/appStore.4bbf92eb.svg";